import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {filterComponents, filterServices, filterUtils} from './index';
import {SharedModule} from '../shared/shared.module';
import {DynamicFormModule} from '../shared/dynamic-form/dynamic-form.module';
import {LayoutModule} from '../layout/layout.module';
import {DialogModule} from 'primeng/dialog';
import {SelectButtonModule} from 'primeng/selectbutton';
import {SharedModule as PNGShared} from 'primeng/api';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {ClickOutsideModule} from 'ng-click-outside';
import {CheckboxModule} from 'primeng/checkbox';
import {DropdownModule} from 'primeng/dropdown';
import {StoreModule} from '@ngrx/store';
import {filterReducer} from './store/filter.reducer';
import {ManageFilterComponent} from './components/manage-filter/manage-filter.component';
import {AggregatorModule} from "@ispm-client/modules/aggregator/aggregator.module";
import {EditorModule} from "primeng/editor";
import {CheckBoxModule as DLSCheckboxModule} from '@wuitk/angular/components/checkbox';

@NgModule({
    imports: [
      CoreModule,
      FormsModule,
      TableModule,
      DialogModule,
      ClickOutsideModule,
      StoreModule.forFeature('filters', filterReducer),
      SharedModule,
      EditorModule,
      LayoutModule,
      DynamicFormModule,
      SelectButtonModule,
      PNGShared,
      CheckboxModule,
      DropdownModule,
      AggregatorModule,
      DLSCheckboxModule
    ],
    declarations: [...filterComponents, ManageFilterComponent],
    exports: [...filterComponents],
    providers: [...filterServices, filterUtils]
  })

  export class FilterModule { }
